const STORAGE_KEY = "CS_SEARCHED_TRACKING_NUMBERS";
export const setSearchedTrackingNumbers = (numbers) => {
    localStorage.setItem(STORAGE_KEY, numbers);
};
export const getSearchedTrackingNumbers = () => {
    const trackingNumbers = localStorage.getItem(STORAGE_KEY);
    return trackingNumbers || null;
};
